import { useEffect } from 'react';
import { useAnalytics } from '../contexts/AnalyticsContext';
import { EventCategory } from '../utils/analyticsUtils';
import {
  onCLS,
  onFCP,
  onLCP,
  onTTFB,
  onINP,
  type Metric
} from 'web-vitals';

/**
 * Hook to track web vitals performance metrics
 * Uses the Web Vitals API to track performance metrics
 */
export const usePerformanceTracking = () => {
  const { trackEvent, hasConsent } = useAnalytics();

  useEffect(() => {
    // Only track performance if user has given consent
    if (!hasConsent) return;

    // Track metrics using the web-vitals API
    const reportWebVital = (metric: Metric) => {
      trackEvent('web_vital', {
        category: EventCategory.PERFORMANCE,
        metric_name: metric.name,
        value: metric.value,
        id: metric.id,
      });
    };

    // Register all the metrics we want to track
    onCLS(reportWebVital);
    onINP(reportWebVital); // INP is the replacement for FID in Web Vitals v5
    onLCP(reportWebVital);
    onFCP(reportWebVital);
    onTTFB(reportWebVital);

  }, [trackEvent, hasConsent]);
};
